import { api, API_MONO, monolithCache } from '../api/api'

export const getDeliveriesForLocationApi = (locationId, date) =>
  api.get(`${API_MONO}/location/${locationId}/schedule?day=${date}&duration=1`, null, {
    cache: monolithCache,
  })

export const getDeliveryDropoffApi = deliveryDropoffId =>
  api.get(`${API_MONO}/deliveries/dropoff/${deliveryDropoffId}`, null, { cache: monolithCache })
